import dt from './node_modules-styled-components-dist-styled-components.browser.esm.js';
import { Callout } from '@vp/swan';

const StyledCallout = dt(Callout)`
  width: fit-content;
`;
const StyledText = dt.span`
  max-width: 13ch;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export { StyledCallout, StyledText };
//# sourceMappingURL=src-components-CampaignCallouts.styles.js.map
